import React, { useMemo, useRef } from 'react';
import classNames from 'classnames';
import JoditEditor, { Jodit } from 'jodit-react';
import renderMessage from '../renderMessage';
import { required } from '../../../utils/validation';
import './TextInputStyles.scss';

export default function WysiwygInput(props) {
  const {
    label = '',
    className = '',
    textMuted = '',
    placeholder = '',
    inputProps,
    // Это не криптография! Если ваш анализатор этого не понимает не используйте этот анализатор
    // nosemgrep
    controlId = `text-input-${Math.random() * 10000}`,
    dtoObject,
    customValidator = [],
    fieldState = {
      error: '',
    },
    handleShowHelper = () => {},
  } = props;

  const { error = '', touched = false } = fieldState;
  const editor = useRef(null);
  const isError = Boolean(error);
  const {
    onChange,
    value = '',
  } = inputProps;
  const config = useMemo(
    () => ({
      readonly: false, // all options from https://xdsoft.net/jodit/docs/,
      placeholder: placeholder || 'Введите текст...',
      // maxHeight: 300, // Алексей зачем то добавил это сюда
      language: 'ru',
      buttons: Jodit.defaultOptions.buttons.concat([
        {
          name: 'empty',
          icon: 'about',
          exec: () => {
            handleShowHelper();
          },
        },
      ]),
      removeButtons: ['link', 'image', 'video', 'file', 'print', 'speechRecognize', 'spellcheck', 'classSpan', 'subscript', 'superscript', 'ai-commands', 'ai-assistant', 'about'], // fullsize
    }),
    [placeholder],
  );
  const isRequired = (dtoObject
      && dtoObject.validators
      && dtoObject.validators.length
      && !!dtoObject.validators.find(validator => validator.toString() === required.toString()))
    || !!customValidator.find(validator => validator.toString() === required.toString());
  return (
    <div className={classNames('form-control-wrapper', className)}>
      <label htmlFor={controlId} className="form-label">
        {renderMessage(label)}{isRequired ? <span className="form-label-mark-required">*</span> : null}
      </label>
      <JoditEditor
        ref={editor}
        value={value}
        config={config}
        tabIndex={1} // tabIndex of textarea
        // onBlur={newContent => onChange(newContent)} // preferred to use only this option to update the content for performance reasons
        onChange={newContent => onChange(newContent)}
      />
      {textMuted ? <div id={`${controlId}-help`} className="form-text">{renderMessage(textMuted)}</div> : null}
      {isError ? <div className="invalid-feedback">{renderMessage(error)}</div> : null}
    </div>

  );
}
